import Http from '../common/http';
import ApiUtil from '../utils/api.util';
import StringUtil from "../utils/string.util";

const RESOURCE_NAME = 'student';

const DatabaseService = {
  getPagedResult({
  	  page,limit,filters
  }) {
    const filterQueryString = ApiUtil.buildFilter(filters);

    // Always exclude students whose source is flagged as excluded (e.g. survey
    // sources like "Enquête étudiants").
    return Http.get(`/${RESOURCE_NAME}?page=${page}&limit=${limit}&excludeExcludedSources=1&${filterQueryString}`);
  },
  getOneById(id) {
    return Http.get(`/${RESOURCE_NAME}/${id}`);
  },
  downloadExcel(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Http.post(`/${RESOURCE_NAME}/export/${id}`, null, false, {
          responseType: 'blob',
        });

        const headers = response.headers;
        const data = response.data;

        let fileName = ApiUtil.getFileNameFromHeader(headers);

        if (fileName) {
          fileName = StringUtil.rawurldecode(fileName);
        }

        if (!fileName) {
          fileName = `Database_${id}.pdf`;
        }

        resolve({
          data,
          fileName
        });
      } catch (e) {
        reject(e);
      }
    });
  },
  update(id, data) {
    return Http.post(`/${RESOURCE_NAME}/${id}`, data);
  },
  remove(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
  forwardToBrevo(id) {
    return Http.post(`/${RESOURCE_NAME}/${id}/forward-brevo`);
  }
};

export default DatabaseService;
